import React from 'react';
import ChapterContainer from '../platformui/ChapterContainer';
import withViewport from '../platformui/Base/Sensors/viewport';
import withAnchorNavTrigger from '../platformui/Containers/withAnchorNavTrigger';

const ChapterContainerBlock = (props) => <ChapterContainer {...props} />;
export default withViewport(withAnchorNavTrigger(ChapterContainerBlock));